import { Component, OnInit } from '@angular/core';
//import { ToastrService } from 'ngx-toastr';
import { GlobalConstants } from 'src/app/shared/constants/global-constants';
import { UserModel } from 'src/app/shared/models/user.model';
import { UserService } from 'src/app/shared/services/user.service';
import { GlobalNotification} from "src/app/shared/constants/global-notification";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  profile : UserModel;
  form  = UserModel.getFormGroup();
  countryList : string [];
  constructor(public service: UserService,
    //private toastr:ToastrService
    private gnotify : GlobalNotification
    ) {
    this.countryList = GlobalConstants.constCountryArray;
  }

  ngOnInit() {
    //this.service.formModel.reset();
    this.refreshUserProfile();
  }
  getCountryString(code)
  {
    return GlobalConstants.getCountryString(code);
  }
  refreshUserProfile()
  {
    console.log("refreshUserProfile");
    this.service.getUserProfile().subscribe(
      res=>{
        console.log("getUserProfile");
        this.profile = res as UserModel;
        this.form.setValue(this.profile);
      },
      err=>{

      }
    );

  }

  onSubmit() {
    console.log("onSubmit");

    this.service.updateProfile(this.form.value).subscribe(
      (res : any) => {
        if (res.succeeded) {

          ////this.toastr.success("The profile changed!", "Change profile successful");
          this.gnotify.showSnackBar('Change profile', 'The profile changed!', "success");
        }
        else {
          res.errors.forEach(element => {
            ////this.toastr.error(element.desription, "Change profile failed");
            this.gnotify.showSnackBar('Change profile', element.desription, "error");
          });
        }
      },
        err => {
          if(err.status == 400)
          {
            //this.toastr.error(err.error.message, "Error");
            this.gnotify.showSnackBar('Change profile', err.error.message, "error");
          }
          else{
            ////this.toastr.error(err.desription, "Error");
            this.gnotify.showSnackBar('Change profile', err.desription, "error");
          }

        }
    );

  }


}
